import React, { useState } from "react";
import {
  Button,
  ButtonGroup,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Menu,
  MenuItem,
  TableCell,
  Tooltip,
} from "@mui/material";
import {
  Preview as PreviewIcon,
  Email as EmailIcon,
  SendTimeExtension as SendTimeExtensionIcon,
  Description as DescriptionIcon,
  Download as Download,
  Delete as DeleteIcon,
  CheckCircle as CheckCircleIcon,
  MoreVert as MoreVertIcon,
  ContentCopy as ContentCopyIcon,
  Leaderboard as LeaderboardIcon,
  Autorenew as RenewIcon,
  Cancel as CancelIcon 
} from "@mui/icons-material";
import { Link } from "react-router-dom";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import RenewInwardModal from "./RenewInwardModal";

const SrfActionButtons = ({
  row,
  isCSRF,
  editAccess,
  showComponent,
  handleOpen,
  SetSelectedColumn,
  submitSiteDelete,
  srfApproved,
  srfWithdraw,
  handlePrintModalOpen,
  handleOpenTimeline,
  handleOpenAuditModal,
  settings,
  handleSrfCopy,
  updateSrfDetails,
  openErrorModal,
   ...restProps
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [open, setOpen] = useState(false);
  const [selectedEntryDate, setSelectedEntryDate] = useState(null);
  const [calibrationDate, setCalibrationDate] = useState(null);

  const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);
  const userType = localStorage.getItem("type");

  const open1 = Boolean(anchorEl);

  return (
    <TableCell>
      <ButtonGroup size="small" aria-label="small button group">
        <Tooltip title="Edit SRF" placement="top-start">
          <Button
            id="srflist-editsrf"
            component={Link}
            to={`/inward/editInward/${row.id}`}
          >
            <PreviewIcon />
          </Button>
        </Tooltip>

          <Tooltip title="Renew Inward" placement="top-start">
          <Button
            id="srflist-editsrf"
            onClick={(e) => {
                if (window.confirm("Really want to Renew Inward?")) {
                  setOpen(true);
                }
              }}
          >
            <RenewIcon />
          </Button>
        </Tooltip>

        <Tooltip title="Download Srf" placement="top-start">
          {isCSRF ? (
            <Button onClick={() => handlePrintModalOpen(row.id)}>
              <Download />
            </Button>
          ) : (
            <Button
              id="srflist-printsrf"
              component={Link}
              to={`/srf/printSrf/${row.id}`}
            >
              <Download />
            </Button>
          )}
        </Tooltip>

        {showComponent("delete") && (
          <Tooltip title="Delete Srf" placement="top-start">
            <Button
              id="srflist-deletesrf"
              disabled={!(userType == 1)}
              onClick={(e) => {
                if (window.confirm("Really want to delete srfs?")) {
                  submitSiteDelete(row.id);
                }
              }}
            >
              <DeleteIcon
                style={{
                  color: !(userType == 1) ? "lightgray" : "red",
                }}
              />
            </Button>
          </Tooltip>
        )}

        <Tooltip title="More Options" placement="top-start">
          <Button
            aria-controls={open1 ? "actions-menu" : undefined}
            aria-haspopup="true"
            onClick={handleMenuOpen}
          >
            <MoreVertIcon />
          </Button>
        </Tooltip>
      </ButtonGroup>


      <Menu
        id="actions-menu"
        anchorEl={anchorEl}
        open={open1}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <MenuItem
          onClick={() =>
            handleOpenTimeline(row.id, row.customerName, row.serviceReqNumber)
          }
        >
          <Tooltip title="Progress List" placement="top-start">
            <Button style={{ padding: "2px 0px" }}>
              <LeaderboardIcon /> &nbsp;&nbsp; Progress
            </Button>
          </Tooltip>
        </MenuItem>

        <MenuItem
          onClick={() => {
            SetSelectedColumn(row);
            handleOpen();
          }}
        >
          <Tooltip title="Send Email" placement="top-start">
            <Button id="srflist-srfmail" style={{ padding: "2px 0px" }}>
              <EmailIcon /> &nbsp; &nbsp; Mail
            </Button>
          </Tooltip>
        </MenuItem>

        <MenuItem>
          <Tooltip title="Dispatch" placement="top-start">
            <Button
              id="srflist-srfdispatch"
              component={Link}
              to={`/srf/dispatch/${row.id}/${row.clientId}`}
              style={{ padding: "2px 0px" }}
            >
              <SendTimeExtensionIcon /> &nbsp; &nbsp; Dispatch
            </Button>
          </Tooltip>
        </MenuItem>

        <MenuItem>
          <Tooltip title="Dispatch Status" placement="top-start">
            <Button
              id="srflist-srfdispatchstatus"
              component={Link}
              to={`/srf/DispatchStatus/${row.id}`}
              style={{ padding: "2px 0px" }}
            >
              <DescriptionIcon /> &nbsp; &nbsp; Dispatch Status
            </Button>
          </Tooltip>
        </MenuItem>

        <MenuItem>
          <Tooltip
            title="Approved Srf"
            placement="top-start"
            onClick={(e) => row.approvedby ? srfWithdraw(row.id) : srfApproved(row.id)}
            style={{ padding: "2px 0px" }}
          >
            <Button>
              {row.approvedby ? <CancelIcon /> : <CheckCircleIcon />}
              &nbsp; &nbsp; {row.approvedby ? "SRF Withdraw" : "SRF Approved"}
            </Button>
          </Tooltip>
        </MenuItem>

        {settings?.["AuditSRF"] && settings?.["AuditSRF"]?.value == "true" && (
        <MenuItem
          onClick={() => {
            handleMenuClose();
            handleOpenAuditModal(row); 
          }}
        >
          <Button
            id="srflist-srfaudit"
            style={{ padding: "2px 0px" }}
          >
            <DescriptionIcon /> &nbsp; &nbsp; Audit
          </Button>
        </MenuItem>
        )}
      </Menu>

      <RenewInwardModal
        open={open}
        onClose={() => setOpen(false)}
        row={row}
        onConfirm={(entryDate, instrumentIds, extraDates ) =>
          handleSrfCopy(
            row.id,
            settings,
            updateSrfDetails,
            restProps,
            openErrorModal,
            entryDate,
            null,
            instrumentIds, // only these instruments are copied
            extraDates
          )
        }
      />
    </TableCell>
  );
};

export default SrfActionButtons;
